import { Img } from '@/components/blocks/MaterialImage';
import {
	ContentRecommendation,
	EmptyLoadingElement,
} from '@/components/content/ContentRecommendation';
import { Stack } from '@mui/material';
import React from 'react';

const emsName = 'DPV2FooterDPLogos';
const dpstreetSrc = '/dpstreetLogos.png';
const dportenisSrc = '/dportenisLogos.png';

interface DpLogosMobileProps {
	breakToMobileFooter: boolean;
}

export const DpLogosMobile: React.FC<DpLogosMobileProps> = () => (
	<Stack>
		<Stack direction="row" gap={'9px'}>
			<a href="https://www.dpstreet.mx" target="_blank" rel="noopener noreferrer">
				<Img
					sx={{
						height: '26px !important',
						width: '100px',
						objectFit: 'cover',
					}}
					src={dpstreetSrc}
					alt="dpstreet"
				/>
			</a>
			<a href="https://www.dportenis.mx" target="_blank" rel="noopener noreferrer">
				<Img
					sx={{ height: '26px !important', width: '100px', objectFit: 'cover' }}
					src={dportenisSrc}
					alt="dportenis"
				/>
			</a>
		</Stack>
	</Stack>
);

export const DpLogos = () => (
	<ContentRecommendation
		id={`footer-${emsName}`}
		properties={{ emsName }}
		loadingElement={<EmptyLoadingElement />}
	/>
);
